<template>
    <div class="service-results service-results-downloads" v-show="resultsCount">
        <div class="service-resultoptions form-flat">

            <div class="dropdown results-filter hidden">
                <button class="btn btn-flat dropdown-toggle" data-toggle="dropdown" type="button"><i
                        class="icon icon-filter"></i>{{$t("service_download.filter_sorting.filter")}}
                    <span class="caret"></span></button>
                <ul class="dropdown-menu">
                    <li><a class="action action-filter" href="#">Filter 1</a></li>
                </ul>
            </div>
            <div class="dropdown results-sorting">
                <button class="btn btn-flat dropdown-toggle" data-toggle="dropdown" type="button"><i
                        class="icon icon-sorting"></i>{{sortingText}}
                    <span class="caret"></span></button>
                <ul class="dropdown-menu">
                    <li :class="{'active' : sorting === sort }" v-for="sort in sortings"><a :class="['sort-'+sort]"
                                                                                            class="action action-filter"
                                                                                            v-on:click.stop="setSorting(sort,$event)">{{$t("service_download.filter_sorting."+sort)}}</a>
                    </li>
                </ul>
            </div>
        </div>
        <loader :loading="resultState === 'loading'"></loader>

        <download-result-group :group-type="type.id" :key="type.id" :raw-results="groups[type.id]"
                               :sorting="sorting"
                               v-for="(type) in types" v-show="resultState === 'finished'"></download-result-group>

    </div>
</template>

<script>

    import DownloadResultGroup from "./DownloadResultGroup";
    import Loader from "./Loader";

    let scrollOptions = {
        force: false,
        cancelable: true,
        offset: -100
    };

    export default {
        name: "ServiceDownloadsResults",
        props: ['results'],
        data: function () {
            return {
                sortings: [
                    'asc', 'desc', 'date_asc', 'date_desc'
                ],
                filter: null,
                sorting: null
            };
        },
        components: {
            DownloadResultGroup,
            Loader
        },
        methods: {
            setSorting(sort, e) {
                e.preventDefault();
                this.sorting = sort;
            }
        },
        watch: {
            results() {
                if (this.results && this.resultState === 'finished') {
                    let self = this;

                    self.$nextTick(function () {
                        self.$scrollTo(self.$el, 1000, scrollOptions);
                    })

                }
            },
        },
        computed: {
            sortingText() {
                if (this.sorting === null)
                    return this.$t("service_download.filter_sorting.sorting");
                return this.$t("service_download.filter_sorting." + this.sorting);
            },
            resultState() {
                return this.$store.state.status.results;
            }
            ,
            filterSelection() {
                return this.$store.state.selections.searchFilter;
            },
            types() {
                let $this = this;
                if (this.$store.state.filter) {
                    if (!!$this.filterSelection && !!$this.filterSelection.type_id && !!$this.filterSelection.type_id.length > 0)
                        return this.$store.state.filter.type.filter((i) => {
                            return $this.filterSelection.type_id.indexOf(i.id) !== -1
                        });

                    return this.$store.state.filter.type;
                }

                return null;
            },
            resultsCount() {
                if (!this.results)
                    return 0;
                return Object.keys(this.results).length;
            },
            groups() {
                let buckets = {};
                if (!this.results)
                    return buckets;

                let keys = Object.keys(this.results);
                for (var i = 0; i < keys.length; i++) {
                    const result = this.results[keys[i]];
                    const first = result[Object.keys(result).pop()];
                    let bucket = null;
                    if (first.fields.indexname[0] == 'downloads') {
                        bucket = first.fields.type_id;
                    } else {
                        bucket = [first.fields.indexname[0]];
                    }

                    if (!bucket) {
                        continue;
                    }

                    bucket.forEach(b => {
                        if (!buckets[b]) {
                            buckets[b] = {};
                        }
                        buckets[b][keys[i]] = result;
                    });

                }

                return buckets;
            }
        }

    }
</script>

<style scoped>

</style>
